module.exports = __webpack_public_path__ + "static/ĎulaDusič-7f7b7755b009efc0f78641572b425ffa.jpg";